import Exceed from 'exceed';
import {Feedback} from '@alife/aisc';
import api from './api/api';

const Toast = Feedback.toast;

// Exceed文档 - http://web.npm.alibaba-inc.com/package/exceed
const exceed = new Exceed({
  ENV: 'production',
});

exceed.interceptors.request.push((requestParams) => {
  requestParams.headers = {
    'X-CSRF-TOKEN': window.csrfToken,
    'Ao-Region': window.AK_GLOBAL.region,
    'Ao-Region-Id': window.AK_GLOBAL.regionId,
  };
});
if (window.AoneLayout) {
  AoneLayout.utils.ajaxFilterThunk('exceed', exceed, (text) => {
    Toast.error(text, 'danger')
  })
}

exceed.interceptors.response.error.push((response, msg, t, config) => {
  if (msg) {
    Toast.error(msg);
  }
});

function apiMapCreator(apimapArr) {
  return apimapArr.map(item => ({
    name: item.name || item,
    id: item.id || item,
    method: item.method || 'get',
    urls: {
      production: item.urls || `/api/${item}`
    },
    type: item.type
  }));
}

exceed.use(apiMapCreator(api));

export default exceed;



/** WEBPACK FOOTER **
 ** ./src/utils/fetch.js
 **/